var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "account-info-component" },
    [
      [
        _c("div", { staticClass: "user_details" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("span", { staticClass: "user_title" }, [
            _vm._v(
              _vm._s(_vm.personalDetails && _vm.personalDetails.FirstName) +
                " " +
                _vm._s(
                  _vm.personalDetails &&
                    _vm.personalDetails.LastName &&
                    _vm.personalDetails.LastName[0]
                ) +
                "."
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "session_details" }, [
            _c("div", { staticClass: "lastlogin" }, [
              _vm._v("Last logged in: "),
              _c("span", [_vm._v(_vm._s(_vm.lastLogin || "--"))])
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v("Session duration: "),
              _c("span", [_vm._v(_vm._s(_vm.sessionTime))])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "account_balance" },
          [
            _vm.showBalance
              ? _c(
                  "v-layout",
                  { attrs: { "justify-center": "" } },
                  [
                    _c(
                      "v-flex",
                      { staticClass: "balance", attrs: { xs6: "" } },
                      [
                        _c("span", { staticClass: "text" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("MyAccount.CurrentBalance")) +
                              " "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "value",
                            on: {
                              click: function($event) {
                                return _vm.getWalletBalance()
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm._f("currency")(_vm.totalCacheBalance))
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("v-flex", { staticClass: "bonus", attrs: { xs6: "" } }, [
                      _c("span", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.$t("MyAccount.SportsbookBonus")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "value",
                          on: {
                            click: function($event) {
                              return _vm.getWalletBalance()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm._f("currency")(_vm.siteCreditBalance))
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.showBalance
                      ? _c(
                          "span",
                          {
                            staticClass: "show_hide_text",
                            attrs: { flat: "" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.toggleShowBalance(_vm.showBalance)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.showBalance ? "Hide" : "Show") +
                                "\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.showBalance
              ? _c(
                  "div",
                  {
                    staticClass: "show_hide",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.toggleShowBalance(_vm.showBalance)
                      }
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.showBalance ? "Hide" : "Show") +
                          "\n        "
                      )
                    ])
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "user_image" }, [
      _c("span", { staticClass: "pd-icon pd-icon-player-icon" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66e58c5d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66e58c5d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/horses/account/AccountInfoComponent.vue
// module id = null
// module chunks = 